import React from "react";
import { NavLink } from "react-router";
import { Checkbox, Icon } from "semantic-ui-react";
import Tooltip from "../../../../components/common/tooltip/Tooltip";
import { Typography } from "../../../../components/common/Typography/Typography";
import { threatDefenseSettingTooltip } from "../../constants";
import environmentConfig from "configuration/environmentConfig";
import styles from "./ThreatDefense.module.scss";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { FeatureFlags } from "../../../../featureFlags";

const helpCenterLink = environmentConfig.helpCenterUrl;
const helpCenterRelativeUrls = environmentConfig.helpCenterRelativeUrls;
const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.whitelistIPAndDomainsUrl}`;

export const MsGraphSettings = ({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}) => (
  <>
    <div className={styles["system-notification-setting"]}>
      <Checkbox
        toggle
        checked={checked}
        disabled={disabled}
        label={"Microsoft Graph Direct Message"}
        onChange={onChange}
        data-testid={"ms-graph-configuration"}
        className={styles["checkbox-style"]}
      />
      <Tooltip
        tooltipClassName={styles["system-notification-setting__tooltip_threat-defence"]}
        className={styles["system-notification-setting__tooltip-target"]}
        target={<Icon className="info circle" />}
        content={threatDefenseSettingTooltip}
        position="right center"
        hoverable
        hideOnScroll
        showAlways
      />
    </div>
    <Typography variant="paragraph" italic>
      <Typography bold component={"span"}>
        Please Note:
      </Typography>{" "}
      This must be completed before sending simulated phishing campaigns to your organization.
    </Typography>
  </>
);

export const AssignedDomainSection = ({ domainName }: { domainName: string | undefined }) => {
  const isCustomSmtpEnabled = useFeatureFlag(FeatureFlags.ThreatDefenceCustomSmtp);

  return (
    <section>
      <Typography variant="title2" bold>
        ASSIGNED DOMAIN
      </Typography>
      <div className={styles["section-content"]}>
        <Typography variant="title2">
          This is the assigned domain for your account:{" "}
          <Typography variant="title2" bold component={"span"}>
            {domainName || "-"}.{" "}
          </Typography>
          {!isCustomSmtpEnabled && "This is the domain that all campaign sends will originate from."}
        </Typography>
      </div>
    </section>
  );
};

export const WhitelistDomainSection = ({ domainName }: { domainName: string | undefined }) => (
  <section>
    <Typography variant="title2" bold>
      WHITE LIST YOUR DOMAIN
    </Typography>
    <div className={styles["section-content"]}>
      <Typography variant="title2" component={"span"}>
        Follow the instructions in our{" "}
        <NavLink target="_blank" className={styles["link"]} to={supportLink}>
          Help Center
        </NavLink>{" "}
        to whitelist your domain{" "}
        <Typography variant="title2" bold component={"span"}>
          {domainName || "-"}.
        </Typography>
      </Typography>
      <Typography variant="paragraph" italic>
        <Typography bold component={"span"}>
          Please Note:
        </Typography>{" "}
        This must be completed before sending simulated phishing campaigns to your organization.
      </Typography>
    </div>
  </section>
);
